import React, { Component } from "react";
import {Row, Col, container, Table} from "react-bootstrap";
import ReactPlayer from "react-player";
import './audioplay.css';


import ExternalLayout from "../../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../../customComponents/RenderPage/RenderPage";
import Strip from "../../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../../customComponents/SEO/SEOComponent";
import PropTypes from "prop-types";


// import Male Audio Samples
import audiom1 from "../../../assets/sampleDatasets/TeluguMale/telugu_health_m.wav";
import audiom2 from "../../../assets/sampleDatasets/TeluguMale/telugu_edu_m.wav";
import audiom3 from "../../../assets/sampleDatasets/TeluguMale/telugu_agri_m.wav";


function Telugu_Male(){
    return( 
    <div className="container">
        <table>
            {/* Table Heading */}
            <thead className="headTable">
            <tr>
                <th className="headTable">Audio</th>
                <th className="headTable">Text</th>
            </tr>
            </thead>
            <tbody>
            <tr> {/* Table Row Sample 1 */}
                <td className="tableEvenRow"><ReactPlayer   
                        url={audiom1}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">బ్రిటన్‌లోని కింగ్స్, కాలేజీ ఆస్పత్రి న్యూరో సర్జన్ కీమౌర్స్ అష్కాన్ వద్ద, ట్యూమర్కు సంబంధించి చికిత్స చేసుకుంటోంది</p></td>
            </tr>
            <tr> {/* Table Row Sample 2 */}
                    <td className="tableOddRow"><ReactPlayer   
                        url={audiom2}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableOddRow"><p className="p-medium-line-spacing">బోధన్ సంయుక్త కలెక్టర్గా అనురాగ్ జయంతిని, మెట్పల్లి సంయుక్త కలెక్టర్గా గౌతమ్, భద్రాచలం సంయుక్త కలెక్టర్గా పమేలా సత్పతి, బెల్లంపల్లి సంయుక్త కలెక్టర్గా రాహుల్రాజ్ను నియమించింది</p></td>
            </tr>
            <tr> {/* Table Row Sample 3 */}
                    <td className="tableEvenRow"><ReactPlayer   
                        url={audiom3}
                        width="400px"
                        height="50px"
                        playing={false}
                        controls={true}
                        type = 'audio/mp3'
                    />
                </td>
                <td className="tableEvenRow"><p className="p-medium-line-spacing">జంతువుల వ్యవసాయం అంతర్గతంగా అసమర్థంగా ఉంటుంది, ఎందుకంటే మొక్కలను ఉత్పత్తి చేసే మొక్కలతో పోల్చితే, జంతువులకు తిండికి మొక్కలను ఉత్పత్తి చేయడానికి ఎక్కువ భూమి, నీరు, ఎరువులు మరియు ఇతరుల వనరులను తీసుకుంటుంది</p></td>
            </tr>
            </tbody>

           
            
        </table>


    </div>

    );
}

const Sample_Telugu_Male = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
            <RenderPage
                id="tst-landing"
                className={`render px-0 ${props.isClassName ? 'render-page ' : 'min-height-auto'}`}
                containerType="container-fluid"
            > 
                <SEOComponent
                    title="SampleMarathiMale"
                    keywords="Speech Recognition, respin, SPIRE LAB, Navana"
                    description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
                    siteUrl="/SampleMarathiMale" />
                   
                    <Strip
                        id="tst-SampleDatasets"
                        className="strip strip-no-padding px-20"
                        containerType="container"
                    >
                   

                    <div className="mx-0  pt-5">  
                        <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Sample Telugu Male Audio</h5>
                            <div className="mx-0 mb-5 pb-5">
                                <Telugu_Male />
                            </div>
                    </div>

</Strip>
</RenderPage>
</ExternalLayout>
);
};

export default Sample_Telugu_Male;